import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from '@lingui/macro';

import { Link, Tag } from '@decisiv/ui-components';

import { formatIsoDay } from '../../utils/dates';
import {
  EmptyState,
  EntryDate,
  EntryMeta,
  EntryRow,
  EntryTitle,
  PanelFooter,
  PanelWrapper,
} from './style';

export default function WhatsNewPanel({ entries, onSeeAll = undefined }) {
  return (
    <PanelWrapper data-testid="whats-new-panel">
      {entries.length === 0 ? (
        <EmptyState>
          <p>
            <Trans>No updates yet</Trans>
          </p>
        </EmptyState>
      ) : (
        entries.map((entry) => (
          <EntryRow key={entry.id}>
            <EntryTitle>{entry.title}</EntryTitle>
            <EntryMeta>
              <EntryDate>{formatIsoDay(entry.date)}</EntryDate>
              {entry.module && (
                <Tag text={entry.module} size="small" variant="outline" />
              )}
            </EntryMeta>
          </EntryRow>
        ))
      )}
      <PanelFooter>
        <Link
          to="/whats-new"
          size="small"
          text={<Trans>See All</Trans>}
          onClick={onSeeAll}
        />
      </PanelFooter>
    </PanelWrapper>
  );
}
WhatsNewPanel.propTypes = {
  entries: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      date: PropTypes.string.isRequired,
      module: PropTypes.string,
    }),
  ).isRequired,
  onSeeAll: PropTypes.func,
};
